export const MONTHLY = 'monthly';
export const QUARTERLY = 'quarterly';
export const PER_SIX_MONTHS = 'per_six_months';
export const ANNUALLY = 'annually';
export const PER_TWO_YEARS = 'per_two_years';
export const PER_THREE_YEARS = 'per_three_years';
export const PER_FOUR_YEARS = 'per_four_years';
export const PER_FIVE_YEARS = 'per_five_years';
export const PRICE_RATES_OBJECT = Object.freeze({
  [MONTHLY]: 1,
  [QUARTERLY]: 3,
  [PER_SIX_MONTHS]: 6,
  [ANNUALLY]: 12,
  [PER_TWO_YEARS]: 24,
  [PER_THREE_YEARS]: 36,
  [PER_FOUR_YEARS]: 48,
  [PER_FIVE_YEARS]: 60
});